import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const ContentContainer = styled(Box)`
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.shades.shade200}`};
  background: ${({ theme }) => theme.colors.neutral.shades.shade100};
`;

export const DashedDivider = styled('div')`
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
  height: 1px;
  background: ${({ theme }) => `repeating-linear-gradient(
    to left,
    ${theme.colors.neutral.shades.shade300}, /* Color of the dashes */
    ${theme.colors.neutral.shades.shade300} 5px, /* Dash height */
    transparent 5px, /* Start of the gap */
    transparent 10px /* Gap height */
  )`};
`;
